/**工资更正单 */
import { $http, buildHeaders } from "./index";

//获取列表
export const taxdeclarecorrect_list = (params) => {
  return $http.get("/admin/TaxDeclareCorrect/index", {
    params,
  });
};

//获取详情
export const taxdeclarecorrect_detail = (id) => {
  return $http.get("/admin/TaxDeclareCorrect/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取税期月份
export const taxdeclarecorrect_taxmonth = (id) => {
  return $http.get(
    "/admin/TaxDeclareCorrect/taxMonth?tax_declare_correct_id=" + id
  );
};

//获取员工列表
export const taxdeclarecorrect_employee = (params) => {
  return $http.get("/admin/TaxDeclareCorrectEmployee/index", {
    params,
  });
};

//根据扣缴义务人id获取人员列表
export const taxdeclarecorrect_withholdingagent_employee_list = (params) => {
  return $http.get("/admin/TaxDeclareCorrect/withholdingAgentEmployee", {
    params,
  });
};

//添加
export const taxdeclarecorrect_add = (data) => {
  return $http.post("/admin/TaxDeclareCorrect/add", data, {
    headers: buildHeaders(3),
  });
};

//修改
export const taxdeclarecorrect_edit = (data) => {
  return $http.post("/admin/TaxDeclareCorrect/edit", data, {
    headers: buildHeaders(3),
  });
};

//设置当月不申报
export const taxdeclarecorrect_setresignation = (data) => {
  return $http.post("/admin/TaxDeclareCorrectEmployee/setResignation", data, {
    headers: buildHeaders(3),
  });
};
